import { ModelRow } from "@mcleod/core";
import { DesignableObject } from "../base/DesignableObject";
import { Event, EventListener } from "./Event";

export interface DataDisplayListener extends EventListener<DataDisplayEvent> {
}

/**
 * An event that is fired when either a single component displays its data (when the component/target is a Component),
 * or when a DataSource finishes displaying data to its bound components (when the component/target is a DataSource).
 */
export class DataDisplayEvent extends Event<DesignableObject> {
    rowData: ModelRow = null;
    allData: ModelRow[] = null;
    rowIndex: number = -1;

    constructor(component: DesignableObject, rowData: ModelRow, allData: ModelRow[], rowIndex: number) {
        super(component);
        this.rowData = rowData;
        this.allData = allData;
        this.rowIndex = rowIndex;
    }
}
